import React, { useEffect } from "react";
import ReactCountryFlag from "react-country-flag";

import { Select } from "antd";

import { getCountryCodeForCurrency } from "utils/utils";

function SelectCurrencyRxComponent(props) {
  return (
    <div>
      <Select
        showSearch
        {...props}
        size="large"
        value={props.currency}
        onChange={(value) => props.setCurrency(value)}
      >
        {props.allowedCurrencies &&
          props.allowedCurrencies.map((currency) => {
            return (
              <Select.Option value={currency} key={currency}>
                <ReactCountryFlag code={getCountryCodeForCurrency(currency)} />
                <span style={{ marginLeft: "5px" }}>{currency}</span>
              </Select.Option>
            );
          })}
      </Select>
    </div>
  );
}

export default SelectCurrencyRxComponent;
